import "packages/frontend/core/src/desktop/dialogs/setting/workspace-setting/byok/index.css.ts.vanilla.css!=!../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"packages/frontend/core/src/desktop/dialogs/setting/workspace-setting/byok/index.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAE8VX23KbMBB971doJtOZZCbKADaOQ976JwJJoJRbJGE77fTfqwvIAuO42J32AV902d2zl7PLE9utK_EegJ9fAMBMtCX6SAAtyeFVLehviBknmWRNnYCsKbuq1js5ahMQrVt17NeXJyskNELShmPCExC2ByCakmGwQ_weQkQpqwncRVCpIByyWjBMvpnT0F56eHX3IUeYdSIB29ZY0uwIp2WzT0DBMCbGhhRl33PedDVOzug4noAtZxXiHw-evdE8aFSyvIZMkkqpz0gtCdfLb52QjH7ArFErtUyAaFFGYErknpCjT8LIGtwijFmd2wUQbuxqOsCVsqmu9ZEDsDIAqDIICvaDTLxg1yvjVPN7T1heKMM3QaDXVDAbfuo5SQ5yzlvry8oOwigr9ULRK4sCi_wzbYIop-KJvnhpSp6Jm4nKehKUSKWVM83YYG4f7zkzNsvMcPeex_dyzrCxRn0r0JValQTaW8JWEggpB6iTzSUw_zLFnpMSCQmzgpXYK28nPvDObs2BMwhXkUXonX8x5xtVRkwqFwVP6-3isp5NHXRbYR-39gzLYuA5AFxOr0euHqhqsyzT_wbS1CA9ozHtVIxqr5bHGu9oQJ8p9aRlRloPesinAbT9787iafDi-O9AIp9BmnFi1nGhj-YcpRermRrhFathj9Iw4dK-N257-aJsMwL6pja14x8xeWFDN9NRzY3jBilL1gomTCkUCgo0PS8BdbPnqL1oct8PFlM_-4RzteIEDOqNN8eJ-ebT1FCaLy8v0w6g6KgPg4chDO3SqIWF_6Gwv_tVcJeuo1V4Qo53lNKYxt6t8spUdAKqOedtZ9rNkf5umPRu9lJ91dg6xPOYC_N83uO-2sxbPeRgNtfBjEahba8SMul8K1J5It__eCRcTAHciHZq-4wbWlMQfLXuPWjFJoZuLvkskjcmrEuYQJlwwh1nKXs8D0dXZJXfwv-M7BW_d1Ir1mRdE9-zSaIyICNFUypcF5utd3YUn4Q2WSd8ulgwhei4FQjrHqP86B7NyTxP0f0qeARhrD6iVfyoZotV4OsWt413JuNJjU-6MeK5asiyOWFFaacGu89tHIdB_XL2OzHdLKe77d1oO9xsUexv7xe9UHDSEiSNI9WUUaHDvarkRz2APzycOMt3xqTgw3UwZf9N_7Ixff0_uNnK5fosrepXHf0EdugZdbQ43WKiR9LfLYrtP5gQAAA\"}!../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var bar = 'iv4msqx';
export var capabilityIcon = 'iv4msqa';
export var capabilityIconActive = 'iv4msqb';
export var capabilityIconSvg = 'iv4msqc';
export var capabilityRow = 'iv4msq8';
export var capabilityRowInactive = 'iv4msq9';
export var chart = 'iv4msqw';
export var dangerTag = 'iv4msqk';
export var description = 'iv4msq4';
export var dragHandle = 'iv4msqe';
export var empty = 'iv4msq5';
export var error = 'iv4msqu';
export var field = 'iv4msqp';
export var form = 'iv4msqo';
export var input = 'iv4msqr';
export var label = 'iv4msqq';
export var locked = 'iv4msqn';
export var modalActions = 'iv4msqs';
export var notice = 'iv4msqm';
export var panel = 'iv4msq1';
export var panelHeader = 'iv4msq2';
export var row = 'iv4msq7';
export var rowActions = 'iv4msql';
export var rowDescription = 'iv4msqh';
export var rowDisabled = 'iv4msqd';
export var rowMain = 'iv4msqf';
export var rowTitle = 'iv4msqg';
export var rows = 'iv4msq6';
export var stack = 'iv4msq0';
export var success = 'iv4msqv';
export var tag = 'iv4msqj';
export var tags = 'iv4msqi';
export var testStatus = 'iv4msqt';
export var title = 'iv4msq3';